import * as notifications from '@store/notifications/notifications.const';

import * as auth from './auth';
import * as countries from './countries';
import * as ecsl from './ecsl';
import * as entities from './entities';
import * as filingStatus from './filingStatus';
import * as filingTypes from './filingTypes';
import * as gameChanger from './gameChanger';
import * as helpHero from './helpHero';
import * as notes from './notes';
import * as org from './organization';
import * as period from './period';
import * as savedFilingPeriod from './savedFilingPeriod';
import * as standardTemplate from './standardTemplate';
import * as submission from './submission';
import * as taxCodes from './taxCodes';
import * as upload from './upload';
import * as vatNumbers from './vatNumbers';
import * as vatReturn from './vatReturn';
import * as vsuiteHelp from './vsuiteHelpWindow';

export default {
  ...upload,
  ...auth,
  ...org,
  ...countries,
  ...vatNumbers,
  ...period,
  ...filingTypes,
  ...filingStatus,
  ...entities,
  ...standardTemplate,
  ...savedFilingPeriod,
  ...entities,
  ...ecsl,
  ...taxCodes,
  ...submission,
  ...vatReturn,
  ...notes,
  ...gameChanger,
  ...vsuiteHelp,
  ...helpHero,
  ...notifications,
};
